import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 2,
  style: {"margin":"0"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Wohnadresse definieren", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Du hast noch keine Wohnadresse angelegt!", -1)
const _hoisted_4 = {
  key: 3,
  class: "ion-margin",
  id: "homeChallengeOverview"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", null, "Challenges", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_avatar_menu = _resolveComponent("avatar-menu")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_refresher_content = _resolveComponent("ion-refresher-content")!
  const _component_ion_refresher = _resolveComponent("ion-refresher")!
  const _component_news_info = _resolveComponent("news-info")!
  const _component_welcome_profile_info = _resolveComponent("welcome-profile-info")!
  const _component_last_tracking_card = _resolveComponent("last-tracking-card")!
  const _component_active_tracking_card = _resolveComponent("active-tracking-card")!
  const _component_favorite_track_list = _resolveComponent("favorite-track-list")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_challenge_teaser = _resolveComponent("challenge-teaser")!
  const _component_statistic_overview = _resolveComponent("statistic-overview")!
  const _component_ExploreContainer = _resolveComponent("ExploreContainer")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_TrackingButton = _resolveComponent("TrackingButton")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($setup.mobiDashboardTitle), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_avatar_menu, { "show-points": true })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, {
        fullscreen: true,
        class: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_refresher, {
            slot: "fixed",
            onIonRefresh: _cache[0] || (_cache[0] = ($event: any) => ($setup.refreshData($event)))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_refresher_content)
            ]),
            _: 1
          }),
          _createVNode(_component_ion_header, { collapse: "condense" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_title, { size: "large" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($setup.mobiDashboardTitle), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_news_info, {
            "show-banner": true,
            "show-card": false,
            "show-popup": false
          }),
          _createVNode(_component_news_info, {
            "show-banner": false,
            "show-card": false,
            "show-popup": true,
            "force-reload": false
          }),
          _createVNode(_component_welcome_profile_info),
          _createVNode(_component_news_info, {
            "show-banner": false,
            "show-card": true,
            "show-popup": false,
            "force-reload": false
          }),
          (!$setup.hasActiveTracking && $setup.hasLastTracking)
            ? (_openBlock(), _createBlock(_component_last_tracking_card, {
                key: 0,
                id: "last-active-tracking-component"
              }))
            : _createCommentVNode("", true),
          ($setup.hasActiveTracking)
            ? (_openBlock(), _createBlock(_component_active_tracking_card, {
                key: 1,
                id: "active-tracking-component"
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_favorite_track_list),
          (!$setup.hasHomeLocation)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_ion_card, { class: "ion-margin" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_card_header, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card_title, {
                          class: "ion-align-items-center ion-justify-content-start",
                          style: {"display":"flex","color":"var(--ion-color-warning)"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, {
                              icon: $setup.icons.homeOutline,
                              style: {"margin-right":".25em"}
                            }, null, 8, ["icon"]),
                            _hoisted_2
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_card_content, null, {
                      default: _withCtx(() => [
                        _hoisted_3,
                        _createVNode(_component_ion_button, {
                          color: "primary",
                          onClick: $setup.addAddress
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, {
                              icon: $setup.icons.addOutline,
                              style: {"margin-right":".25em"}
                            }, null, 8, ["icon"]),
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _createTextVNode("Wohnadresse hinzufügen")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        ($setup.hasLocations)
                          ? (_openBlock(), _createBlock(_component_ion_button, {
                              key: 0,
                              color: "medium",
                              onClick: $setup.openUserLocationOverview
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, {
                                  icon: $setup.icons.listOutline,
                                  style: {"margin-right":".25em"}
                                }, null, 8, ["icon"]),
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Adressen verwalten")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          ($setup.firstJoinedOrOpenChallenge)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _hoisted_5,
                _createVNode(_component_challenge_teaser, {
                  uuid: $setup.firstJoinedOrOpenChallenge.uuid,
                  "show-progress": "full"
                }, null, 8, ["uuid"])
              ]))
            : _createCommentVNode("", true),
          _withDirectives(_createVNode(_component_statistic_overview, null, null, 512), [
            [_vShow, false]
          ]),
          _createVNode(_component_ExploreContainer, { name: "Tab 1 page" })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_footer, null, {
        default: _withCtx(() => [
          (!$setup.hasActiveTracking)
            ? (_openBlock(), _createBlock(_component_TrackingButton, { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}